import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { VueAxios } from './utils/request'

import initialization from './core/initialization'
import './core/bootstrap'
import './assets/stylus/index.styl'

// 是否在console中显示log
Vue.config.productionTip = false
Vue.use(VueAxios)

new Vue({
  router,
  store,
  created: initialization,
  render: (h) => h(App) // 渲染组件到应用中
}).$mount('#app')
